export const tokens = {
  primary: '#287891',
  primaryDark: '#1d5a6e',
  primaryTint: '#e8f0f3',
  successTint: '#e3efe7',
  warnTint: '#fdf3e3',
  errorTint: '#fbe9e7',
  success: '#2E8B57',
  bg: '#F5F7F9',
  surface: '#FFFFFF',
  surfaceAlt: '#FAFBFC',
  border: '#E3E8EC',
  divider: 'rgba(0,0,0,0.12)',
  text: 'rgba(0,0,0,0.87)',
  textSecondary: 'rgba(0,0,0,0.60)',
  textDisabled: 'rgba(0,0,0,0.38)',
  radius: 8,
  shadowSm: '0 1px 2px rgba(15, 35, 50, 0.06), 0 0 0 1px rgba(15, 35, 50, 0.04)',
  shadow: '0 2px 8px rgba(15, 35, 50, 0.06), 0 0 0 1px rgba(15, 35, 50, 0.04)',
};
